import Spruce from '@ryangjchandler/spruce'

Spruce.store('chat', {
    messages: []
});

export default Spruce
